module.exports = __webpack_public_path__ + "static/media/menu.9bc8f222.svg";